import React from "react";
import { useTranslation } from "react-i18next";

export default function CreateEndpointUsingJsonParams() {
  const { t } = useTranslation("help");

  return (
    <div className="endpoint-container">
      <a href="#create-endpoint-json" className="endpoint-title">
        {t("CreateEndpointUsingJsonParams.title", "Create Endpoint using JSON params")}
      </a>

      <pre className="code-block">
        <code>{`import requests
import json

API_KEY = ""  # ${t("CreateEndpointUsingJsonParams.required", "Required")}
SESSION_KEY = ""  # ${t("CreateEndpointUsingJsonParams.required", "Required")}
ENDPOINT_NAME = ""  # ${t("CreateEndpointUsingJsonParams.required", "Required")}
ENDPOINT_DESCRIPTION = ""  # ${t("CreateEndpointUsingJsonParams.optional", "Optional")}
ENDPOINT_TYPE = ""  # ${t("CreateEndpointUsingJsonParams.required", "Required")};  ${t("HaCreateProfile.mustBeOneof", "Optional")} api_endpoint,
llm_model_endpoint, mcp_endpoint
ENDPOINT_PARAMS = {  # ${t("CreateEndpointUsingJsonParams.required", "Required")}
    "url": "",  # ${t("CreateEndpointUsingJsonParams.required", "Required")}; ${t("CreateEndpointUsingScripts.vurl")}
    "selection": "json_parameters",  # ${t("CreateEndpointUsingJsonParams.required", "Required")}; ${t("CreateEndpointUsingScripts.mbe")} json_parameters"
}
JSON_PARAMETERS = {  # ${t("CreateEndpointUsingJsonParams.required", "Required")}
    "request": {},  # ${t("CreateEndpointUsingJsonParams.required", "Required")}; ${t("CreateEndpointUsingScripts.mustbevalidjson")} (can be {})
    "response": {},  # ${t("CreateEndpointUsingJsonParams.required", "Required")}; ${t("CreateEndpointUsingScripts.mustbevalidjson")} (can be {})
}

url = f"https://demo.whitehax.com/api/endpoint-config/create/"

payload = {
    "endpoint_name": ENDPOINT_NAME,
    "endpoint_desc": ENDPOINT_DESCRIPTION,
    "endpoint_type": ENDPOINT_TYPE,
    "endpoint_params": json.dumps(ENDPOINT_PARAMS),
    "json_parameters": json.dumps(JSON_PARAMETERS),
}

headers = {"Authorization": API_KEY, "X-Session-Key": SESSION_KEY}

response = requests.request("POST", url, headers=headers, data=payload)

print(response.text)`}</code>
      </pre>

      <style>{`
        .endpoint-container {
          width: 100%;
          box-sizing: border-box;
          background: #1f1f1f;
          color: #f5f5f5;
          padding: 0;
          font-family: Arial, Helvetica, sans-serif;
        }

        .endpoint-title {
          display: inline-block;
          margin-bottom: 26px;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }

        .endpoint-title:hover {
          color: #b7ddf2;
        }

        .code-block {
          margin: 0;
          padding: 0;
          background: transparent;
          color: #d4d4d4;
          font-family: Consolas, "Courier New", monospace;
          font-size: 14px;
          line-height: 1.45;
          white-space: pre-wrap;
          overflow-x: auto;
          tab-size: 4;
        }

        .code-block code {
          font-family: inherit;
        }

        @media (max-width: 768px) {
          .endpoint-title {
            font-size: 15px;
            margin-bottom: 20px;
          }

          .code-block {
            font-size: 13px;
            line-height: 1.45;
            overflow-x: auto;
          }
        }
      `}</style>
    </div>
  );
}